import React from 'react';
import classNames from 'classnames';
import { Collapse } from 'antd';

export const ProfileCollapse = ({
  className,
  ...props
}: React.ComponentProps<typeof Collapse>) => {
  return (
    <Collapse
      className={classNames('profile-collapse', className)}
      {...props}
    />
  );
};

ProfileCollapse.Panel = Collapse.Panel;
